import type {WordIdToWord} from '$lib/data/wordIdToWord';
import {SentenceManager} from '$lib/classes/manager/sentence-manager';
import type {WordIdChanges} from '$lib/data/word-id-changes';
import type {UserWord} from '$lib/classes/data/user-word';

export function validateUserWords(
    userWords: UserWord[],
    wordIdToWord: WordIdToWord,
    sentenceManager: SentenceManager,
    wordIdChanges: WordIdChanges
) {

    const validated = []
    const toSave = []
    const toDelete = []

    for (let userWord of userWords) {

        const foundWord = wordIdToWord[userWord.id]

        if (!foundWord) {
            console.warn('NO Word found for wordId >>', userWord.id)
            toDelete.push(userWord)
            const newWordId = wordIdChanges[userWord.id]
            if (newWordId) {
                const foundWordWithNewId = wordIdToWord[newWordId]
                if (foundWordWithNewId) {
                    console.warn('NEW wordId >>', newWordId)
                    userWord = userWord.withId(newWordId)
                } else {
                    console.warn(`NO word found for wordIdChange ${userWord.id} >> ${newWordId}`)
                    continue
                }
            } else {
                console.warn('NO new wordId found')
                continue
            }
        }

        const sentenceId = userWord.sentenceId
        const sentences = sentenceManager.getSentences(userWord.id)
        const sentenceWithSavedIdFound = sentences.some(sentence => sentence.id === sentenceId)
        const wordIdHasSentences = sentences.length > 0
        const newSentenceId = wordIdHasSentences ? sentences[0].id : null

        if ((sentenceId && sentenceWithSavedIdFound) || (!sentenceId && !wordIdHasSentences)) {
            if (foundWord) {
                validated.push(userWord)
            } else {
                toSave.push(userWord)
            }
        } else if ((sentenceId && !sentenceWithSavedIdFound)) {
            console.warn('NO Sentence with id >> ', sentenceId, ' found containing ', userWord.id,
                wordIdHasSentences ? ` >> new sentence: ${sentences[0].sentence}` : ` >> NO other sentence found`)
            const withNewSentenceId = userWord.withSentenceId(newSentenceId)
            toSave.push(withNewSentenceId)
        } else if (!sentenceId && wordIdHasSentences) {
            console.warn('Sentence ADDED for >> ', userWord.id, ' >> ', sentences[0].sentence)
            const withNewSentenceId = userWord.withSentenceId(newSentenceId)
            toSave.push(withNewSentenceId)
        }
    }

    return {validated, toSave, toDelete}
}